export const DEFAULT_CONFIG_NAMES = [
  'farm.config.ts',
  'farm.config.js',
  'farm.config.cjs',
  'farm.config.mjs',
  'farm.config.cts',
  'farm.config.mts'
];

export const FARM_DEFAULT_NAMESPACE = 'FARM_DEFAULT_NAMESPACE';

export const CUSTOM_KEYS = {
  external_record: 'external.record',
  runtime_isolate: 'runtime.isolate',
  resolve_dedupe: 'resolve.dedupe',
  css_locals_conversion: 'css.modules.locals_conversion',
  assets_mode: 'assets.mode',
  output_ascii_only: 'output.ascii_only'
};

export const FARM_RUST_PLUGIN_FUNCTION_ENTRY = 'func.js';
